import type { ReactElement } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text, View } from 'react-native'
import { tv } from 'tailwind-variants'

import { useFlowsServicesResponses } from '@flows-ui/services/FlowServicesResponsesContext'
import { processStepContentElementText } from '@flows-ui/utils/processStepContentElementText'
import type {
  HarmonyTitle as HarmonyTitleProps,
  Subtitle,
} from '@flows/core/types/stepContentTypes'
import type { FlowValues } from '@flows/core/types/stepTypes'
import InfoButton from '@ui-kit/components/InfoButton'
import { h3 } from '@ui-kit/core/typography'

import { titleStyles } from './Title'

const harmonyTitleStyles = tv({
  extend: titleStyles,
  variants: {
    hasModalContent: {},
    align: {
      center: { container: 'justify-center' },
      left: { container: 'justify-start' },
      right: { container: 'justify-end' },
    },
  },
  defaultVariants: {
    align: 'center',
  },
})

export const HarmonyTitle = <
  TProps extends HarmonyTitleProps<any, any, any> | Subtitle<any, any, any>,
>(
  props: TProps & {
    flowValues: FlowValues
    isSubtitle?: boolean
    modalContent?: ReactElement
    fontSize?: 'primary' | 'secondary'
  }
) => {
  const { t } = useTranslation()
  const servicesResponses = useFlowsServicesResponses()
  const translateFunction = processStepContentElementText(t, {
    flowValues: props.flowValues,
    servicesResponses,
  })

  if (!props.text) {
    return null
  }

  const title = translateFunction(props.text)
  const { container } = harmonyTitleStyles({
    hasModalContent: Boolean(props.modalContent),
  })

  return (
    <View
      className={container({
        align: props.align,
      })}
    >
      <Text
        className={h3({
          align: props.align,
          type: props.fontSize === 'primary' ? 'primary' : 'secondary',
          color: 'black',
        })}
      >
        {title}
      </Text>
      {props.modalContent ? (
        <InfoButton
          type="info"
          modalContent={props.modalContent}
          backdrop={props.infoButton?.backdrop}
        />
      ) : null}
    </View>
  )
}
